import { ReflectionsResponse } from '@api/assessmentQuestionnaireApiHandler';
import EmptyIcon from '@assets/images/icons/wellbeing-journal-empty.svg';
import { MotionImage, MotionText } from '@shared/atoms';
import { SystemButton } from '@shared/molecules';
import { formatDateToDateFullMonthYearWithTodayAndYesterday } from '@utils/date.util';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './index.module.scss';

interface JournalSectionProps {
  reflections?: ReflectionsResponse[] | [];
}

export const JournalSection: React.FC<JournalSectionProps> = ({ reflections }) => {
  const history = useHistory();

  return (
    <div
      className={styles.journalSection}
      aria-labelledby="journal-heading"
      onClick={() => {
        if (reflections?.length === 0) {
          history.push('/journal');
        }
      }}
      style={reflections?.length === 0 ? { cursor: 'pointer' } : { cursor: 'default' }}
    >
      <div className={styles.journalHeader}>
        <MotionText
          className={styles.sectionTitle}
          id="journal-heading"
          as="h3"
          text="Your journal"
        />

        <SystemButton
          className={styles.journalButton}
          aria-label="Open journal"
          onClick={() => history.push('/journal')}
        >
          Journal
        </SystemButton>
      </div>

      {reflections && reflections?.length > 0 ? (
        <>
          <div className={styles.journalEntries}>
            {reflections &&
              reflections.slice(0, 2).map((entry, index) => (
                <div key={index} className={styles.journalEntry}>
                  <MotionText
                    className={styles.journalDate}
                    as="text"
                    text={
                      entry?.createdAt
                        ? formatDateToDateFullMonthYearWithTodayAndYesterday(entry?.createdAt)
                        : 'No date'
                    }
                  />

                  <MotionText
                    className={styles.journalContent}
                    as="text"
                    text={entry?.reflection || 'No reflection text'}
                  />
                </div>
              ))}
          </div>
          <div
            onClick={() => history.push('/journals')}
            className={styles.viewJournalLink}
            aria-label="View your complete journal"
          >
            View your journal &gt;
          </div>
        </>
      ) : (
        <div className={styles.emptyJournal}>
          <MotionImage src={EmptyIcon} alt="" aria-hidden="true" className={styles.emptyIcon} />
          <MotionText as="h4" text="What's on your mind today?" />
          <MotionText
            as="text"
            text="This is your private space to write down thoughts and help you process emotions and gain clarity."
          />
        </div>
      )}
    </div>
  );
};

JournalSection.defaultProps = {
  reflections: [],
};
